import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  ButtonGroup,
  Button,
  Spinner,
} from "reactstrap";
import ReactApexChart from "react-apexcharts";
import { useSelector } from "react-redux";
import axios from "axios";
import config from "config/config";

const ImpressionsChart = ({ syncKey }) => {
  const activeOrganization = useSelector(
    state => state.organizationReducer.activeOrganization
  );

  const organizations = useSelector(
    state => state.organizationReducer.organizations
  );
  const isConsolidatedView = useSelector(
    state => state.organizationReducer.isConsolidatedView
  );
  const userData = useSelector(state => state.Login.userData);

  const mode = useSelector(state => state.Layout.layoutMode);

  const [dataGranularity, setDataGranularity] = useState("monthly");
  const [isLoading, setIsLoading] = useState(false);

  const [chartData, setChartData] = useState({
    options: {
      chart: { toolbar: { show: false } },
      xaxis: { categories: [] },
      yaxis: { title: { text: "Engagements" } },
    },
    series: [],
  });

  const fetchInsights = async (force = false) => {
    setIsLoading(true);

    try {
      const organizationIds = isConsolidatedView
        ? organizations.map(org => org.Organization.id)
        : [activeOrganization.id];

      const resp = await axios.get(
        `${config.backendUrl}/facebook/dashboard/engagements-chart`,
        {
          params: {
            organizationIds: organizationIds.join(","),
            granularity: dataGranularity,
            force,
          },
          headers: { Authorization: `Bearer ${userData.token}` },
          skipLoader: true,
        }
      );

      setChartData({
        options: {
          ...chartData.options,
          xaxis: { categories: resp.data.categories },
        },
        series: resp.data.series,
      });
    } catch (err) {
      console.error("Error loading impressions chart", err);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    fetchInsights();
  }, [dataGranularity, activeOrganization, isConsolidatedView]);

  useEffect(() => {
    if (syncKey) fetchInsights(true);
  }, [syncKey]);

  return (
    <Card className="br" style={{ minHeight: "350px" }}>
      {isLoading ? (
        <div
          style={{
            minHeight: "350px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Spinner size="lg" style={{ color: mode === "dark" ? "#fff" : "#2990DF" }} />
        </div>
      ) : (
        <CardBody style={{ minHeight: "50vh" }}>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h4 className="card-title">Post Engagements</h4>

            <ButtonGroup>
              <Button
                size="sm"
                onClick={() => setDataGranularity("monthly")}
                style={{
                  minWidth: "150px",
                  backgroundColor: dataGranularity === "monthly" ? "#2990DF" : "transparent",
                  color: dataGranularity === "monthly" ? "#fff" : "#666",
                  borderColor: "#2990DF",
                }}
              >
                Monthly (1 Year)
              </Button>

              <Button
                size="sm"
                onClick={() => setDataGranularity("daily")}
                style={{
                  minWidth: "150px",
                  backgroundColor: dataGranularity === "daily" ? "#2990DF" : "transparent",
                  color: dataGranularity === "daily" ? "#fff" : "#666",
                  borderColor: "#2990DF",
                }}
              >
                Daily (2 Weeks)
              </Button>
            </ButtonGroup>
          </div>

          <Row>
            <ReactApexChart
              options={chartData.options}
              series={chartData.series}
              type="line"
              height="290"
            />
          </Row>
        </CardBody>
      )}
    </Card>
  );
};

export default ImpressionsChart;
